import React from "react";
import { Check } from "lucide-react";
import { ABOUT_IMG } from "../lib/assets";
import { useLang } from "../context/LangContext";

const About = () => {
  const { t } = useLang();

  return (
    <section id="about" data-testid="about-section" className="py-24 sm:py-32 bg-brand-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -inset-6 bg-brand-orange/20 rounded-[2rem] -rotate-3" />
            <div className="relative rounded-[2rem] overflow-hidden border-4 border-white shadow-xl">
              <img
                src={ABOUT_IMG}
                alt="Despre BIU BIU DRIVING"
                className="w-full h-[500px] object-cover"
                data-testid="about-image"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-brand-navy text-white rounded-2xl p-5 shadow-2xl max-w-[220px]">
              <p className="font-display text-3xl font-extrabold text-brand-orange">100%</p>
              <p className="text-sm font-medium mt-1">Dedicare pentru fiecare cursant</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <p className="text-xs sm:text-sm uppercase tracking-[0.22em] font-bold text-brand-orange mb-4">
            {t.about.eyebrow}
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-brand-navy leading-tight tracking-tight">
            {t.about.title}
          </h2>

          <p className="mt-6 text-base sm:text-lg text-brand-muted leading-relaxed">{t.about.p1}</p>
          <p className="mt-4 text-base sm:text-lg text-brand-muted leading-relaxed">{t.about.p2}</p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {t.about.bullets.map((b, i) => (
              <li key={b} className="flex items-start gap-3" data-testid={`about-bullet-${i}`}>
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-orange/15 flex items-center justify-center mt-0.5">
                  <Check className="w-3.5 h-3.5 text-brand-orange-deep" strokeWidth={3} />
                </div>
                <span className="text-brand-navy font-medium text-sm sm:text-base">{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
